import { render, staticRenderFns } from "./shareFolder.vue?vue&type=template&id=3cc783f4&scoped=true"
import script from "./shareFolder.vue?vue&type=script&lang=js"
export * from "./shareFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc783f4",
  null
  
)

export default component.exports